var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-warning btn-rounded btn-sm mr-2",on:{"click":_vm.exportToExcel}},[_c('i',{staticClass:"fa fa-download"})])
}
var staticRenderFns = []

export { render, staticRenderFns }